export type FontWeightTypes = typeof fontWeight;
export type FontSizeTypes = typeof fontSize;
export type FontFamilyTypes = typeof fontFamily;
export type LineHeightTypes = typeof lineHeight;

/** Pretendard — 사이트 전역 서체 */
export const fontFamily = {
	sans: "'Pretendard Variable', Pretendard, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
} as const;

/** 제목·본문·캡션 줄간격 */
export const lineHeight = {
	tight: 1.2,
	snug: 1.35,
	normal: 1.5,
	relaxed: 1.6,
	loose: 1.75,
} as const;

export const fontWeight = {
	weightThin: 100,
	weightLight: 300,
	weightRegular: 400,
	weightMedium: 500,
	weightSemi: 600,
	weightBold: 700,
	weightBlack: 900,
};

export const fontSize = {
	size2xs: '1.2rem',
	sizeXs: '1.3rem',
	sizeSm: '1.4rem',
	sizeMd: '1.6rem',
	sizeLg: '1.8rem',
	sizeXl: '2rem',
	size2xl: '2.4rem',
	size3xl: '2.8rem',
	size4xl: '3.2rem',
	size5xl: '3.6rem',
	size6xl: '4rem',
	size7xl: '4.8rem',
};
